module.exports = __webpack_public_path__ + "img/42600.55659712.jpg";